"use strict";

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var NodeHandlerAdapter_1 = require("./NodeHandlerAdapter");
/**
 * A handler for converting GraphQL definition nodes to operations.
 */


var NodeHandlerDefinitionAdapter =
/*#__PURE__*/
function (_NodeHandlerAdapter_) {
  _inherits(NodeHandlerDefinitionAdapter, _NodeHandlerAdapter_);

  function NodeHandlerDefinitionAdapter(targetKind, util, settings) {
    _classCallCheck(this, NodeHandlerDefinitionAdapter);

    return _possibleConstructorReturn(this, _getPrototypeOf(NodeHandlerDefinitionAdapter).call(this, targetKind, util, settings));
  }

  return NodeHandlerDefinitionAdapter;
}(NodeHandlerAdapter_1.NodeHandlerAdapter);

exports.NodeHandlerDefinitionAdapter = NodeHandlerDefinitionAdapter;